
export const LINKS = {
    QUESTIONNAIRE_URL: '/questionnaire'
}
